import LayoutMain from '@Layouts/LayoutMain';
import usePage from '@Queries/usePage';
import useTranslation from '@Queries/useTranslation';
import PageTopBar from '@Components/PageTopBar';
import H2 from '@Components/H2';
import MainGallery from './elements/MainGallery';
import TopArticles from './elements/TopArticles';
import PopularTags from './elements/PopularTags';
import DynamicCatalog from './elements/DynamicCatalog';
import Page from '@Components/Page';
import styles from './PageWikiMain.module.css';

import type { PageWikiMainData } from './typings';
import type { FC } from 'react';

const PageWikiMain: FC = () => {
  const { data: page } = usePage<PageWikiMainData>();
  const { popularTags, interactiveMenu, priorityArticles } = page;
  const { t } = useTranslation();

  return (
    <LayoutMain>
      <Page>
        <PageTopBar
          title={page.meta.h1}
          breadcrumbs={page.breadcrumbs}
          navigation={page.nav.map((item) => ({
            active: item.active,
            name: item.title,
            href: item.link,
          }))}
        />
        <div data-testid='page-wiki-main'>
          <div className={styles.wrapper}>
            <MainGallery mainGallery={interactiveMenu} className={styles.mainGallery} />
          </div>

          <TopArticles articles={priorityArticles} className={styles.topArticles} />

          <div className={styles.wrapper}>
            {popularTags?.length > 0 && (
              <PopularTags tags={popularTags} className={styles.popularTags} />
            )}

            <H2 title={t('related-title')} className={styles.additionalOffers} />
          </div>

          <DynamicCatalog className={styles.dynamicCatalog} />
        </div>
      </Page>
    </LayoutMain>
  );
};

export default PageWikiMain;
